module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0027.jpg?v=5f314c8f";